import { AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';

import GetPageSettingResponse from '../Responses/PageSettingResponse';

import PageSettings from 'Api/Models/PageSettings';

class PageSettingApi extends AbstractCRMApi {
    public endpoint: string = 'page-setting';

    public getByKey(key: string): Promise<GetPageSettingResponse> {
        return this.get(`/${key}`).then((response: AxiosResponse<GetPageSettingResponse>) => response.data);
    }

    public async update(pageSettings: PageSettings): Promise<PageSettings> {
        return this.put(`/${pageSettings.key}`, pageSettings).then((response: AxiosResponse) =>
            PageSettingApi.mapDataPageSettingItemClass(response.data));
    }
}

export default new PageSettingApi();
